import React from "react";
import PropTypes from "prop-types";
import DefaultHeadRenderer from "./DefaultHeadRenderer";
import DefaultCellRenderer from "./DefaultCellRenderer";
import DefaultRowRenderer from "./DefaultRowRenderer";

import "./DynamicTableData.scss";

import {Spinner} from '@blueprintjs/core';

function DynamicTableData({ data, sort, setSort, fields, rowRenderer, isLoading }) {

  if (isLoading) {
    return <Spinner />
  }

  const heads = Object.keys(fields)
    .map((field) => ({
      field,
      ...fields[field],
      headRenderer: fields[field].headRenderer || DefaultHeadRenderer,
      cellRenderer: fields[field].cellRenderer || DefaultCellRenderer,
    }))
    .filter((head) => head.visible === undefined || head.visible === true)
    .sort((a, b) => a.order - b.order);

  const ThisRowRenderer = rowRenderer || DefaultRowRenderer;

  return (
    <div className="DynamicTableData">
      <table
        className="bp3-html-table bp3-html-table-bordered bp3-html-table-striped"
        width="100%"
      >
        <thead>
          <tr className="DynamicTableData__headRow">
            {heads.map((head) => (
              <head.headRenderer
                key={head.field}
                head={head}
                sort={sort}
                setSort={setSort}
              />
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row) => {
            return (
              <ThisRowRenderer
                key={Math.random().toString(36).substring(2)}
                heads={heads}
                row={row}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
DynamicTableData.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  fields: PropTypes.objectOf(PropTypes.shape).isRequired,
  sort: PropTypes.shape({
    field: PropTypes.string,
    order: PropTypes.string,
  }).isRequired,
  setSort: PropTypes.func.isRequired,
  rowRenderer: PropTypes.func,
};

DynamicTableData.defaultProps = {
  rowRenderer: null
};

export default DynamicTableData;
